export default "__VITE_ASSET__BJiGHNaW__"